<template>
    <v-flex class="no-results-available">
        {{message}}
    </v-flex>
</template>

<script>
    export default {
        name: 'NoResultsAvailable',
        props: {
            message: {
                type: String,
                required: true,
            },
        },
    };

</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .no-results-available {
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        padding-top: 10px;
        margin-right: 30px;
        font-style: italic;
        font-family: Raleway,serif;
        letter-spacing: 0.42px;
        border-top: 1px solid $ypo-tile-border;
    }

</style>
